export default __webpack_public_path__ + "static/1679-907070b855aab1da5252d2ea235bd394.gif";